import imgEtherne1 from "./img-etherne (1).png";
import imgEtherne2 from "./img-etherne (2).png";

const imgEtherne = [imgEtherne1, imgEtherne2];

export default imgEtherne;
